<template>
  <v-container fluid>
    <v-row>
      <div class="header">
        <h2>Создание новости</h2>
      </div>
      <div class="horizontal-rule"/>
    </v-row>

    <CreationForm class="mt-6"/>

  </v-container>

</template>

<script>

import CreationForm from "@/components/NewCreationPageComponents/CreationForm";

export default {
  name: "ArticleCreationPage",
  components: { CreationForm },


  data() {
    return {
      newAuthor: '',
      newTitle: '',
      newContent: '',

      nameRules: [
        v => !!v || 'Поле не может быть пустым',
      ],
      valid: true,
    }
  },
}
</script>

<style scoped>

</style>